<template>
  <div class="flex items-center gap-2 h-10">
    <label v-if="label" class="font-semibold text-dark-blue">{{ label }}</label>
    <select
      v-model="internalSelected"
      @change="emitSelection"
      class="bg-white p-1 focus:ring-0 focus:border-0 outline-none shadow-none h-10"
    >
      <option disabled value="" class="default-option" v-if="!internalSelected">
        {{ placeholder }}
      </option>
      <option v-if="locations.length === 0" disabled value="">
        No locations
      </option>
      <option
        v-else
        v-for="location in locations"
        :key="location.id"
        :value="location.name"
      >
        {{ location.name }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { locations as getLocations } from "@/services/location/location.js";
import { defineEmits, defineProps, onMounted, ref, watch } from "vue";

const props = defineProps({
  modelValue: { type: String, default: "" },
  placeholder: { type: String, default: "Select Location" },
  label: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
  selectFirst: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue", "selected"]);

const locations = ref([]);
const internalSelected = ref(props.modelValue);

onMounted(async () => {
  const response = await getLocations();
  locations.value = response.data?.locations;

  if (props?.selectFirst && locations.value.length > 0) {
    internalSelected.value = locations.value[0].name;
    emitSelection();
  }
});

watch(
  () => props.modelValue,
  (val) => {
    internalSelected.value = val;
  }
);

function emitSelection() {
  emit("update:modelValue", internalSelected.value);
  emit("selected", internalSelected.value);
}
</script>
